import { Typography } from '@/components/Typography'
import styles from './AdLabel.module.scss'

const AdLabel = () => (
  <Typography as="div" variant="xs" className={styles.label}>
    Anzeige
  </Typography>
)

export default AdLabel
